module.exports = __webpack_public_path__ + "img/Apresentacao_ao_Publico.5fe007f7.jpeg";